import React, { useRef, memo } from 'react';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { Card } from 'react-bootstrap';
import {
  TooltipComponent,
  TitleComponent,
  GridComponent
} from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { useAppContext } from '../../../providers/AppProvider';
import dayjs from 'dayjs';

echarts.use([
  TooltipComponent,
  TitleComponent,
  GridComponent,
  BarChart,
  CanvasRenderer
]);

const getDefaultOptions = (theme, getThemeColor, activeData, breakData) => {
  const categories = Object.keys(activeData || breakData);
  const seriesData = [];
  console.log('CATEGORIES  ', categories);
  // Add ACTIVE_TIME series if data exists
  if (activeData) {
    seriesData.push({
      name: 'ACTIVE',
      type: 'bar',
      data: categories.map(machine => {
        const machineData = activeData[machine];
        return machineData?.[machineData.length - 1]?.[1] || 0; // Get the total active time
      }),
      barWidth: '12px', // Adjust bar width
      itemStyle: { borderRadius: [2, 2, 0, 0], color: getThemeColor('primary') }
    });
  }

  // Add BREAK_TIME series if data exists
  if (breakData) {
    seriesData.push({
      name: 'BREAK',
      type: 'bar',
      data: categories.map(machine => {
        const machineData = breakData[machine];
        return machineData?.[machineData.length - 1]?.[1] || 0; // Get the total break time
      }),
      barWidth: '12px', // Adjust bar width
      itemStyle: {
        borderRadius: [2, 2, 0, 0],
        color: getThemeColor('secondary')
      }
    });
  }
  console.log('SERIES DATA ', seriesData);

  return {
    color: seriesData.map(series => series.itemStyle.color),
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: params => {
        return params
          .map(
            ({ seriesName, value, axisValue }) =>
              `<div>${axisValue} - ${seriesName}: ${value} hours</div>`
          )
          .join('');
      }
    },
    xAxis: {
      type: 'category',
      data: categories, // Machines as x-axis categories
      axisLabel: {
        color: getThemeColor('gray-800'),
        fontFamily: 'Nunito Sans',
        fontWeight: 600,
        fontSize: 12.8
      },
      axisLine: {
        lineStyle: {
          color: getThemeColor('gray-300')
        }
      },
      axisTick: {
        alignWithLabel: true
      }
    },
    yAxis: {
      type: 'value',
      axisLine: { lineStyle: { color: getThemeColor('gray-300') } },
      splitLine: {
        show: true,
        lineStyle: { color: getThemeColor('gray-300') }
      },
      axisLabel: {
        color: getThemeColor('gray-900'),
        formatter: '{value} hours'
      }
    },
    series: seriesData,
    grid: {
      right: 40,
      left: 20,
      bottom: '30px', // Adjust to accommodate labels
      top: '10%',
      containLabel: true
    },
    animation: false,
    barCategoryGap: '30%' // Space between categories
  };
};

const ActiveBreakBarChart = ({ activeData, breakData, title }) => {
  console.log('ACTIVE DATA ', activeData);
  console.log('BREAK DATA ', breakData);

  const chartRef = useRef(null);
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  return (
    <Card className="h-100">
      <Card.Body>
        <div style={styles.headerContainer}>
          <div style={styles.title}>{title}</div>
        </div>
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getDefaultOptions(
            theme,
            getThemeColor,
            activeData,
            breakData
          )}
          style={{ height: '316px', width: '100%' }}
        />
      </Card.Body>
    </Card>
  );
};

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold'
  }
};

export default memo(ActiveBreakBarChart);
